export default "__VITE_ASSET__DQuAXJqd__"